import React, { useState } from 'react'
import '../assets/css/productCard.css'
import { useNavigate } from 'react-router-dom'

function ProductCard({ product }) {
    const navigate = useNavigate()
    const [zoomOpen, setZoomOpen] = useState(false)

    const openZoom = () => setZoomOpen(true)
    const closeZoom = () => setZoomOpen(false)

    return (
        <>
            <div className="product-card" style={{ margin: 'auto' }}>
                <div className="product-image-wrapper">
                    <img
                        src={product.images?.[0]}
                        alt={product.title}
                        onClick={openZoom}
                        className="product-image"
                    />
                </div>

                <div className="product-content" style={{ width: '100%' }}>
                    <h3
                        className="product-title"
                        style={{ margin: '0 auto 20px' }}
                        onClick={() => navigate(`/product/${product._id}`)}
                    >
                        {product.title}
                    </h3>

                    <button
                        className="product-btn"
                        onClick={() => navigate(`/product/${product._id}`)}
                        style={{ display: 'block', margin: 'auto' }}
                    >
                        <span className="btn-text-wrap">
                            <span className="btn-text">View Details</span>
                            <span className="btn-text btn-text-abs">View Details</span>
                        </span>
                    </button>
                </div>
            </div>

            {/* ZOOM MODAL */}
            {zoomOpen && (
                <div className="image-zoom-overlay" onClick={closeZoom}>
                    <div
                        className="image-zoom-container"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="zoom-close-btn" onClick={closeZoom}>
                            ✕
                        </button>

                        <img
                            src={product.images?.[0]}
                            alt={product.title}
                            className="zoomed-image"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default ProductCard
